import React, { useEffect } from "react";
import styles from "./notification.module.css";

export default function Notification({
  open = false,
  onClose = () => {},
  message = "KYC Link Resent to the User Email ID",
  issuerLabel = "Issued by",
  issuerLogo = "/pinelabs.svg", // change path if needed
}) {
  // ESC to close
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={styles.backdrop} aria-hidden={!open}>
      {/* DO NOT close on outside click: no handler on backdrop */}
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="kycResentTitle"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close (X) */}
        <button
          type="button"
          className={styles.closeBtn}
          aria-label="Close"
          onClick={onClose}
        >
          {/* circled X */}
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M18 6L6 18M6 6l12 12" stroke="#4B5563" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>

        {/* Thumbs-up in blue circle */}
        <div className={styles.iconWrap} aria-hidden="true">
          <span className={styles.iconCircle}>
            <svg width="28" height="28" viewBox="0 0 24 24">
              <path fill="#FFFFFF" d="M9 22h-4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h4v11Zm11-9c0-.55-.45-1-1-1h-5.31l.76-3.58.02-.22a1 1 0 0 0-.29-.7l-1-1-5.59 5.59c-.38.38-.59.9-.59 1.41V20a2 2 0 0 0 2 2h6.31c.8 0 1.52-.48 1.83-1.22l2.38-5.56c.12-.28.18-.58.18-.88Z"/>
            </svg>
          </span>
        </div>

        {/* Title */}
        <h2 id="kycResentTitle" className={styles.title}>
          {message}
        </h2>

        {/* Issuer footer (bottom-right) */}
        <div className={styles.issuer}>
          <span className={styles.issuerLabel}>{issuerLabel}</span>
          {issuerLogo ? (
            <img src={issuerLogo} alt="Pine Labs" className={styles.issuerLogo} />
          ) : (
            <span className={styles.issuerPlaceholder}>pine labs</span>
          )}
        </div>
      </div>
    </div>
  );
}
